import styled from "styled-components";

export const Style = styled.div`
  .header {
    display: flex;  

    h2 {
      font-size: 22px;
    }
  }
`;

